import React from 'react';
import { Button } from './ui/Button';
import { ArrowRightIcon, MailIcon, PhoneIcon } from 'lucide-react';
export function CTA() {
  return <section className="py-24 bg-blue-950" data-id="element-1">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-2">
        <div className="mb-4" data-id="element-3">
          <span className="inline-flex items-center px-3 py-1 rounded-full bg-blue-900/60 text-blue-300 text-xs font-medium tracking-wide uppercase" data-id="element-4">
            Начните сегодня
          </span>
        </div>

        <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-5">
          Готовы автоматизировать работу <br className="hidden md:block" data-id="element-6" />с
          документами?
        </h2>

        <p className="text-lg text-blue-200/70 max-w-2xl mx-auto mb-10 leading-relaxed" data-id="element-7">
          Получите бесплатную консультацию от нашей команды. Мы подберём
          оптимальное решение под ваши задачи, объёмы и требования к
          безопасности.
        </p>

        <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12" data-id="element-8">
          <Button variant="primary" size="lg" className="bg-white text-gray-900 hover:bg-gray-100 group" data-id="element-9">
            Получить консультацию
            <ArrowRightIcon className="ml-2 w-4 h-4 group-hover:translate-x-0.5 transition-transform" data-id="element-10" />
          </Button>
          <Button variant="outline" size="lg" className="border-blue-700 text-blue-200 hover:bg-blue-900/50 hover:text-white" data-id="element-11">
            Посмотреть демо
          </Button>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-6 text-sm text-blue-300/60" data-id="element-12">
          <div className="flex items-center gap-2" data-id="element-13">
            <MailIcon className="w-4 h-4" data-id="element-14" />
            <span data-id="element-15">info@scanmind.ai</span>
          </div>
          <div className="hidden sm:block w-1 h-1 rounded-full bg-blue-700" data-id="element-16"></div>
          <div className="flex items-center gap-2" data-id="element-17">
            <PhoneIcon className="w-4 h-4" data-id="element-18" />
            <span data-id="element-19">+7 (495) 123-45-67</span>
          </div>
        </div>
      </div>
    </section>;
}